<template>
  <div class="tag-container">
    <div v-for="(tag, index) in filter_tag" :key="index">
      <div class="filter-tag" v-if="tag.index !== undefined">
        <span class="tag-name">{{tag.value}}</span>
        <span @click="vDeleteTag(tag)" class="delete-tag"><i class="material-icons">close</i></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilterTag',
  data() {
    return {
      filter_tag: Array(),
    }
  },
  methods: {
    vDeleteTag(tag) {
      this.$store.dispatch("recherche/REMOVE_TAG_FILTER", { 
        type: 'uncheck',
        option: tag.key,
        value: tag.value,
        index: tag.index,
        custom_value: tag.custom_value,
        reference: tag.reference
      });
      this.$emit('filter:remove');
    }
  },
  computed: {
    getFilterTag() {
      return this.$store.getters['recherche/get_filter_tag'];
    },
    getRemoveFilterTag() {
      return this.$store.getters['recherche/get_remove_tag_filter'];
    }
  },
  watch: {
    getFilterTag(val) {
      this.filter_tag = val
    },
    getRemoveFilterTag(val) {
      if(val === true) {
        this.$store.dispatch('recherche/SET', {key: 'filter_tag', value: Array()})
      }
    }
  }
}
</script>

<style scoped>
.tag-container {
  display: flex;
  align-items: flex-start;

}
.tag-container p {
  margin: 0;
}
.filter-tag {
  background-color: rgba(0, 0, 0, 0.08);
  border: solid 1px rgba(0, 0, 0, 0.08);
  border-radius: 30px;
  display: flex;
  align-items: center;
  padding: 3px 3px 3px 10px;
  justify-content: space-between;
  margin-right: 10px;
}
.tag-name {
  font-size: .7rem;
  color: rgba(0, 0, 0, 0.7);
} 
.delete-tag {
  display: flex;
  align-items: center;
  border-radius: 50%;
  background-color: rgb(174, 174, 174);
  padding: 2px;
  transition: all .3s;
  margin-left: 5px;
}
.delete-tag:hover {
  background-color: #f00b35;
  cursor: pointer;
}
.delete-tag:hover i {
  color: #fff;
}
.delete-tag i {
  font-size: .75rem;
  color: rgb(218, 218, 218);
  
}
</style>